import React, { PureComponent } from "react";
import HighchartsReact from "highcharts-react-official";
import * as Highcharts from "highcharts";
import { mFormatter } from "../utils";
import { numberWithCommas } from "../../utils";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);
class PlatformWiseMediaBreakdownCharts extends PureComponent {
    state = {};

    chartComponent = React.createRef();

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent.current && this.chartComponent.current.chart.setSize(null, null);
                this.chartComponent.current && this.chartComponent.current.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getOptions = () => {
        let data = this.props.data;
        let total = data.total;
        let self = this;
        let chartData = data.chartData;

        let chartConfig = {
            chart: {
                type: "pie",
                className: "skiptranslate",
                backgroundColor: "transparent",
                // margin: [0, 0, 0, 0],
                // spacingTop: 0,
                // spacingBottom: 0,
                // spacingLeft: 0,
                // spacingRight: 0,
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: "",
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    shadow: false,
                    borderWidth: 0,
                    showInLegend: true,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        distance: "10%",
                        format: "{point.name}: {point.percentage:.1f} %",
                        style: {
                            fontWeight: 400,
                            textOutline: "none",
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
                margin: 0,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series: [
                {
                    // innerSize: "60%",
                    data: chartData,
                    animation: false,
                },
            ],
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                outside: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    zIndex: 2000,
                },
                formatter: function () {
                    return `<span>${data.platformName}</span><br/><span>${this.point.name} | <b>${
                        this.point.percentage.toFixed(1) + "%"
                    }</b> | <b>${numberWithCommas(this.point.doc_count)}</b>/<b>${numberWithCommas(total)} </b></span>`;
                },
            },
        };
        return chartConfig;
    };

    render() {
        return (
            <HighchartsReact
                className="pie-chart"
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "calc(100% - 20px)" } }}
            />
        );
    }
}

export default PlatformWiseMediaBreakdownCharts;
